<template>
    <button
        class="btn border-gray-200 bg-white text-gray-600 hover:border-gray-300"
        :title="$t(title)"
    >
        <fa :icon="icon" />
    </button>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        icon?: string
        title?: string
    }>(),
    {
        icon: 'arrow-left',
        title: 'back',
    }
)
</script>
